import React from 'react'
import Dialog from '@material-ui/core/Dialog';
import styled from 'styled-components'

import { Checkbox, Button } from 'components/common'

const Content = styled.div`
  width: 600px;
  padding: 36px 50px;
`;
const Title = styled.h1`
  font-family: Overpass;
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 37px;
  color: #000000;
  margin: 0;
`;
const Text = styled.p`
  font-family: Overpass;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  color: #444053;
  margin: 26px 0px;
  span {
    background-color: #3F76E6;
    border-radius: 4px;
    padding: 4px 10px;
    color: white;
  }
`;
const ToggleContainer = styled.div`
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #DCE6F2;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 42px 34px;
  width: 100%;
`;
const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
    margin-top: 36px;
  .close-btn {
    margin-left: 26px;
  }
`;
const CloseTicket = ({
  open,
  handleClose,
  onClose,
  onExtended,
  isExtended=false,
  extensionOnly=false,
  disabled=false,
  loading=false
}) => {
  return (
    <Dialog
      onClose={() => {}}
      onBackdropClick={() => {}}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <Content>
        <Title>Close Ticket</Title>
        <Text>
          This action will close the ticket meaning no further 
          returns or pickups will be possible 
          for this ticket.
        </Text>
        <ButtonsContainer>
          <Button variant="grey" onClick={() => handleClose()} disabled={loading}>Cancel</Button>
          <Button variant="error" className="close-btn" onClick={onClose} disabled={loading || disabled}>{loading ? 'Closing...' : 'Close Ticket'}</Button>
        </ButtonsContainer>
      </Content>
    </Dialog>
  )
} 

export default CloseTicket
